<template>
  <div class="textCard">
    <!-- 上半部分盒子 -->
    <div class="card_top">
      <!-- 左侧图片 -->
      <div class="card_img">
        <img
          :src="campList.imgurl==null?'https://fview.5kjs.com/style/camp/banner/camp_img.jpg':campList.imgurl"
          alt=""
          @error="
            campList.imgurl =
              'https://fview.5kjs.com/style/camp/banner/camp_img.jpg'
          "
        />
      </div>
      <!-- 右侧文字区域 -->
      <div class="card_text_box">
        <!-- 标题 -->
        <div>
          <div>
            <p class="card_title">
              {{ jiesuan ? list.camp_name : "图文作业" }}
            </p>
          </div>
          <!-- 时间 -->
          <div class="textCard_time">【第{{ list.day }}天题库作业】</div>
          <!-- 详情 -->
          <div class="card_content_box card_content">
            {{ list.desc }}
          </div>
          <!-- 时间等其他信息 -->
          <div class="card_info">
            <div class="card_info_left" v-if="list.pattern_param">
              <span class="card_number_font"
                >题量：{{ list.pattern_param[0] }}</span
              >

              <span class="card_number_font"
                >满分：{{ list.pattern_param[1] }}分</span
              >
            </div>
          </div>
          <!-- 查看上次刷题结果 -->
          <span class="upinfo" @click="$refs.textClose.open()" v-if="!oneOpen">
            <span>查看上次刷题结果</span>
          </span>
        </div>
        <!-- 报名按钮 -->
        <div class="apply">
          <div class="applyBtn">
            <a href="javascript:;">
              <div class="applyBtn_now" @click="urljup" v-if="oneOpen">
                {{jiesuan ? "开始刷题": "查看图文"}}
              </div>
              <div class="applyBtn_now" @click="urljup" v-else>再刷一次</div>
            </a>
            <div v-if="jiesuan">
              <!-- // 正常打卡结算页 -->
              <textDialog
                v-if="knowledge_id == null"
                ref="textClose"
                @oneOpne="myOneOpen($event)"
              ></textDialog>

              <!-- 章节打卡结算页 -->
              <textDialogSection
                v-else
                ref="textClose"
                @oneOpne="myOneOpen($event)"
              ></textDialogSection>
            </div>
          </div>
          <div class="down">
            <p class="renshu">
              已有：
              <span class="colorOrange">{{ list.sign_num }}人</span>
              完成
            </p>
          </div>
        </div>
      </div>
    </div>


     <!-- 打卡网校不是总校的弹框 -->
    <div
      v-if="changeShool"
      style="
        z-index: 9999;
        left: 50%;
        transform: translate(-50%, -50%);
        width: 400px;
        position: absolute;
        background: none;
        top: 50%;
        background: rgba(255, 255, 255, 1);
        height: auto;
        border-radius: 10px;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        align-items: center;
      "
    >
      <div class="img" style="width: 280px; text-align: center">
        <!-- 客服二维码部分(咨询客服部分要不要用二维码现在还不知道) -->
        <img
          style="width: 280px; max-height: 280px"
          src="https://fview.5kjs.com/activity/21sign/activity_kefu_weixin/2022/02/1a478fd3a697972bc341b894a0a93cf5.png"
          alt=""
        />
        <p style="margin-top: 20px">请跳转总校登录打卡，或咨询客服</p>
      </div>
      <div
        class="boot"
        style="
          padding-bottom: 20px;
          display: flex;
          flex-direction: row;
          align-items: center;
          justify-content: center;
          margin-top: 20px;
        "
      >
        <a href="https://www.jszg.com/home">
          <div
            class="GoHome"
            style="
              height: 40px;
              background: linear-gradient(90deg, #fc4a4a, #ff5d02, #ff9c5c);
              border-radius: 20px;
              line-height: 40px;
              padding: 0 20px;
              color: #fff;
              cursor: pointer;
            "
          >
            跳转总校
          </div>
        </a>
        <!-- <a href="javascript:;">
               <div style="margin-left: 20px;height: 40px;background:linear-gradient(90deg, #FC4A4A, #FF5D02, #FF9C5C);border-radius: 20px;  line-height: 40px;padding: 0 20px;color: #fff;cursor: pointer;">咨询客服</div>
           </a> -->
      </div>
    </div>

  </div>
</template>
<script>
// 正常打卡结算页
import textDialog from "@/components/text_child/text_dialog.vue";
// 章节打卡结算页
import textDialogSection from "@/components/text_child/text_dialogSection.vue";
import { mapState } from "vuex";
export default {
  name: "textCard",
  components: { textDialog, textDialogSection },
  data() {
    return {
      lesson_id: "",
      // 模拟数据
      i: 0,
      campList: {},
      pattern_param: [],
      list: [
        {
          imgage: "/img/cardImge1.0a951779.png",
          title: "",
          content: "",
        },
      ],
      token: localStorage.getItem("token"),
      agency_id: localStorage.getItem("agency_id"),
      // 当前题目是否没有答题
      // 章节打卡的章节ID参数
      knowledge_id: "",
      //当前页面是否为图文打卡页面
      jiesuan: false,
       // 页面加载动画
      loading: this.$loading({
        lock: true,
        text: "加载中",
        spinner: "el-icon-loading",
        background: "rgba(255, 255, 255, 1)",
      }),
      // 不是总校的弹框
      changeShool: false,
    };
  },
  mounted() {
    // 获取章节打卡的章节ID
    this.knowledge_id = this.$route.query.knowledge_id;
    this.lesson_id = this.$route.params.id;
    this.getLesson();
  },
  computed: {
    ...mapState(["oneOpen"]),
  },
  methods: {
    // 跳转考试
    urljup() {

       // 判断当前是否为总校
      var thisUrl = window.location.origin;

      if (thisUrl.search(/(test2.5kjs|hnjszp|www.jszg)/g) == -1) {
        console.log(thisUrl.search(/test2.5kjs|hnjszp|jszg/g));
        console.log("不是总校");
        this.changeShool= true;
        return;
      }

      if (this.jiesuan) {
        // $refs.textClose.open()
        let url = window.location.origin + `${this.list.pattern_url}`;
        if (this.list.is_open == true) {
          this.$alert("课程还未开放", "提示", {
            confirmButtonText: "确定",
          });
          return;
        } else {
          window.location.href = url;
        }
      } else {
        this.$router.push({
          path: `/Detail/imageText/${this.list.camp_id}`,
          query: {
            lesson_id: this.list.lesson_id,
            camp: this.list.camp_id,
            pattern_id: this.list.pattern_id,
          },
        });
      }
    },
    // 获取当前课程信息
    getLesson() {
      this.$axios
        .get("/getLesson", {
          params: {
            token: this.token,
            agency_id: this.agency_id,
            lesson_id: this.lesson_id,
            knowledge_id: this.knowledge_id,
          },
        })
        .then((doc) => {
          if (doc.lesson_type != "graphic_library") {
            this.jiesuan = true;
          }
          this.pattern_param = doc.pattern_param;
          this.list = doc;
          this.$emit("info", doc);
          this.getCamp();
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // 利用科目ID 请求列表的数据
    getCamp() {
      this.$axios
        .get("/getCamp", {
          params: {
            token: this.token,
            agency_id: this.agency_id,
            camp_id: this.list.camp_id,
          },
        })
        .then((doc) => {
          this.campList = doc;
           // 请求返回之后关闭页面加载动画
          this.loading.close();
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
};
</script>

<style lang="less" scoped>
.textCard {
  margin-top: 1.1875rem;
  height: auto;
  width: 100%;
  // 把整个图片分成了上下两部分。
  // top为上半部分，为图片以及课程内容部分
  .card_top {
    // 上半部分的图片部分
    width: 100%;
    height: 20.8125rem;
    display: flex;
    flex-direction: row;
    .card_img {
      width: 28.1875rem;
      height: 20.8125rem;
      border-radius: 0.3125rem;
      img {
        width: 100%;
        height: 100%;
      }
    }
    // 上半部分的右侧文字部分
    .card_text_box {
      flex: 1;
      margin-left: 3.25rem;
      width: 39.375rem;
      height: 100%;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      // 右侧标题
      .card_title {
        font-size: 1.75rem;
        font-family: " Microsoft YaHei";
        font-weight: bold;
        color: #333333;
        line-height: 2rem;
      }
      //   时间部分
      .textCard_time {
        margin-top: 2rem;
        width: 100%;
        height: 1.25rem;
        font-size: 1.25rem;
        font-family: " Microsoft YaHei";
        font-weight: 400;
        color: #ff7d3a;
      }
      // 右侧描述
      .card_content_box {
        margin-top: 1.125rem;
        max-height: 5rem;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 4;
        -webkit-box-orient: vertical;
      }
      .card_content {
        font-size: 0.875rem;
        font-family: "Microsoft YaHei";
        font-weight: 400;
        color: #838383;
      }

      .upinfo {
        display: inline-block;
        cursor: pointer;
        font-size: 0.875rem;
        font-family: "Microsoft YaHei";
        font-weight: bold;
        color: #757c82;
        margin-top: 1.25rem;
        margin-bottom: 0.35rem;
      }
      .upinfo:hover {
        text-decoration: underline;
      }

      // 右侧时间等信息
      .card_info {
        display: flex;
        flex-direction: row;
        margin-top: 1.25rem;
        width: 100%;
        height: auto;
        .card_info_left {
          width: 25.875rem;
          height: 100%;
          .card_number_font {
            font-size: 0.875rem;
            font-family: "Microsoft YaHei";
            font-weight: 400;
            color: #757c82;
          }
        }
        .card_info_font {
          font-size: 0.875rem;
          font-family: "Microsoft YaHei";
          font-weight: 400;
          color: #585858;
          line-height: 1.75rem;
        }
      }
      // 右侧报名按钮
      .apply {
        box-sizing: border-box;
        position: relative;
        width: 100%;
        height: 4.5625rem;
        display: flex;
        // flex-direction: column;
        align-items: center;
        border-radius: 0.4375rem;
        .applyBtn {
          width: 13.8125rem;
          height: 4.5625rem;
          background: linear-gradient(144deg, #ff5a25, #ff7d3a);
          border-radius: 0.4375rem;
          .applyBtn_now {
            font-size: 1.625rem;
            font-family: "Microsoft YaHei";
            font-weight: 400;
            color: #ffffff;
            line-height: 4.5625rem;
            text-align: center;
          }
        }
        .applyBtn:hover {
          background: linear-gradient(144deg, #ff7d3a, #ff5a25);
        }
        .down {
          margin-left: 1.375rem;
          height: 100%;
          display: flex;
          flex-direction: row;
          justify-items: end;
          align-items: flex-end;
          .renshu {
            font-size: 0.875rem;
            font-family: " Microsoft YaHei";
            font-weight: 400;
            color: #7b7b7b;
          }
        }
      }
    }
  }
}
</style>